export default __webpack_public_path__ + "static/media/terminar_entrenamiento.5335aa9a.png";